import mock from './mock';
import './ticket/TicketData';
import './eCommerce/ProductsData';
import './userprofile/PostData';
import './userprofile/UsersData';
import './invoice/invoiceLists';

mock.onAny().passThrough();
